<smrts-page primaryTitle="Modelos de Vistoria">

  <div header class="header-container">
    <button mat-flat-button class="white-text-button btn-novo-modelo" matTooltip="Novo modelo"
      [disableNoPermission]="permissaoEditarRoteiroVistoria" (click)="novoClick()">
      <i class="pi pi-plus button-menu-icon"></i>
      <span class="btn-novo-modelo-label">Novo modelo</span>
    </button>
  </div>

  <div class="content">

    <mat-card class="main-card">

      <p-table [value]="modelos" dataKey="id" class="modelos-table">

        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="nome">Nome<p-sortIcon field="nome"></p-sortIcon></th>
            <th style="width: 120px"></th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-item>
          <tr>
            <td>{{ item.nome }}</td>
            <td>
              <div class="acoes-coluna">
                <button mat-icon-button matTooltip="Editar" [disableNoPermission]="permissaoEditarRoteiroVistoria" (click)="editarClick(item)">
                  <i class="pi pi-pencil"></i>
                </button>
                <button mat-icon-button matTooltip="Duplicar" [disableNoPermission]="permissaoEditarRoteiroVistoria" (click)="duplicarClick(item)">
                  <i class="pi pi-copy"></i>
                </button>
                <button mat-icon-button matTooltip="Remover" [disableNoPermission]="permissaoEditarRoteiroVistoria" (click)="removerClick(item)">
                  <i class="pi pi-trash"></i>
                </button>
              </div>
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="2">Nenhum modelo de vistoria cadastrado</td>
          </tr>
        </ng-template>

      </p-table>

    </mat-card>

  </div>

</smrts-page>
